import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { IdGeneratorService } from 'src/common/services/id-generator.service';
import { ArticleType, ArticleTypeAttribute, BasicArticleDefinitionAttribute } from '../../article-type.model';

@Component({
  selector: 'app-article-type-base-article-definition-editor',
  templateUrl: './article-type-base-article-definition-editor.component.html',
  styleUrls: ['./article-type-base-article-definition-editor.component.scss']
})
export class ArticleTypeBaseArticleDefinitionEditorComponent implements OnInit {


  formGroup = new FormGroup({});

  sourceArticleType: ArticleType;
  articleType: ArticleType;

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<ArticleTypeBaseArticleDefinitionEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private idGenerator: IdGeneratorService
  ) {

    this.sourceArticleType = data.articleType;
    this.articleType = (data.articleType as ArticleType).completeArticleType;

    console.log(this.articleType);

    for (const group of this.articleType.attributeGroups) {
      for (const attribute of group.attributes) {
        this.formGroup.addControl('attribute_' + attribute.id, new FormControl(false, []));
      }
    }

    console.log(this.formGroup);
    for (const attribute of this.articleType.basicArticleDefinition?.attributes) {
      const control = this.formGroup.get('attribute_' + attribute.attributeId);
      if (control) {
        control.setValue(true);
      } else {
        console.log('attribute not in form', attribute.attributeId);
      }

    }

  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {

    this.mapSelection();

    this.dialogRef.close();
  }

  mapSelection() {

    for (const group of this.articleType.attributeGroups) {
      for (const attribute of group.attributes) {
        const control = this.formGroup.get('attribute_' + attribute.id);
        if (control != null && control.value === true) {
          this.setBaseArticleDefinition(attribute);
        } else {
          this.unsetBaseArticleDefinition(attribute.id);
        }
      }
    }
    this.sortBasicArticleDefintionAttributes();
    // am originären ArticleType speichern
    this.sourceArticleType.basicArticleDefinition = this.articleType.basicArticleDefinition;

  }

  unsetBaseArticleDefinition(attributeId: number) {

    let found: BasicArticleDefinitionAttribute = null;

    for (const value of this.articleType.basicArticleDefinition.attributes) {
      if (value.attributeId === attributeId) {
        found = value;
      }
    }

    if (found != null) {
      const index = this.articleType.basicArticleDefinition.attributes.indexOf(found, 0);
      if (index > -1) {
        this.articleType.basicArticleDefinition.attributes.splice(index, 1);
      }
    }

  }

  setBaseArticleDefinition(attribute: ArticleTypeAttribute) {

    for (const attributeValue of this.articleType.basicArticleDefinition.attributes) {
      if (attributeValue.attributeId === attribute.id) {
        return;
      }
    }

    const value = new BasicArticleDefinitionAttribute({
      id: this.idGenerator.getNextId(),
      attributeId: attribute.id
    });
    value.articleTypeAttribute = attribute;

    this.articleType.basicArticleDefinition.attributes.push(value);

  }

  private sortBasicArticleDefintionAttributes() {
    this.articleType?.basicArticleDefinition?.attributes?.sort( (a, b) => {
      if (a == null || a.articleTypeAttribute == null || a.articleTypeAttribute.sortValue == null) {
        return -1;
      }
      if (b == null || b.articleTypeAttribute == null || b.articleTypeAttribute.sortValue == null) {
        return 1;
      }
      return a.articleTypeAttribute.sortValue.localeCompare(b.articleTypeAttribute.sortValue);
    });
  }


}
